export const projects = [
  {
    name: 'dashtabs',
    info: 'QR based order management tool for food businesses',
    stack: ['React', 'Authentication', 'Firebase backend database'],
    links: {
      live: 'http://dashtabs.surge.sh/',
      code: 'https://github.com/pgast/dash-tabs'
    }
  },
  {
    name: 'bitechoice',
    info: 'Find great places to eat near you or anywhere in the world',
    stack: ['NextJS', 'Serverless backend', 'API'],
    links: {
      live: 'https://bite-choice-v2.vercel.app/',
      code: 'https://github.com/pgast/bite-choice-v2' 
    }
  },
  {
    name: 'split',
    info: 'Progressive web app for expense breakdown in events and projects',
    stack: ['React', 'Progressive Web App'],
    links: {
      live: 'http://s-plit.surge.sh/',
      code:  'https://github.com/pgast/split' 
    }
  },
  {
    name: 'weather',
    info: 'Small widget that fetches a 5 day weather forecast of your current location from an API.',
    stack: ['React', 'API'],
    links: {
      live: 'https://quick-weather.vercel.app/',
      code: 'https://github.com/pgast/quick-weather#QuickWeather' 
    }
  },
  // {
  //   name: 'job application manager',
  //   info: 'Helps you keep track of job applications',
  //   stack: ['MongoDB', 'Express.js', 'React', 'Node.js'],
  //   links: {
  //     live: 'https://jobapplication-manager.herokuapp.com/home',
  //     code: 'https://github.com/pgast/job-applications-manager' 
  //   }
  // }
]